import { ref } from 'vue'

import { useTauriEventListener } from '@/shared/composables/tauri'
import { CustomTauriEvent } from '@/shared/types/tauri'

const _url = ref('')
const tauriEvent = useTauriEventListener()

export const tauriMode = () => import.meta.env.VITE_TAURI === 'true'

export const isElectron = () => import.meta.env.VITE_ELECTRON === 'true'

export const appBaseUrl = () => {
  if (tauriMode()) {
    if (import.meta.env.VITE_TAURI_API_DEV_SERVER) {
      _url.value = import.meta.env.VITE_TAURI_API_DEV_SERVER
      return _url.value
    }

    if (!_url.value) {
      tauriEvent.listenEvent(CustomTauriEvent.GET_URL_ADDRESS, (event: { payload: { body: string } }) => {
        _url.value = event.payload.body
      })
      getCurrentUrlCmd().then((url: unknown) => {
        _url.value = url as string
      })
      // Только в dev (Vite): окно на localhost:5555, запросы должны идти через прокси.
      // В generic-сборке location.origin = порт localhost-плагина → отдаёт HTML, не используем.
      if (import.meta.env.DEV && typeof location !== 'undefined' && location.origin) {
        return location.origin + '/'
      }
    }

    return _url.value
  }

  if (isElectron()) {
    return import.meta.env.VITE_SERVER_ELECTRON
  }

  return import.meta.env.VITE_API_DEV_SERVER
}

export const appHost = async () => {
  if(tauriMode()) {
    if(!import.meta.env.VITE_TAURI_API_DEV_SERVER) {
      return getCurrentUrlCmd().then((result) => String(result).split('//')[1])
    }
  }
  return String(appBaseUrl()).split('//')[1]
}

const getCurrentUrlCmd = async (): Promise<string> => {
  const { invoke } = await import('@tauri-apps/api/core')
  const { getCurrentWebviewWindow } = await import('@tauri-apps/api/webviewWindow')
  return invoke('get_current_url_cmd', {
    window: getCurrentWebviewWindow(),
  })
}

/** В Tauri generic-сборке URL бэкенда приходит асинхронно из Rust (реестр/настройки). Ждать его перед первым запросом (напр. /api/env/settings). */
export const ensureAppBaseUrlReady = async (): Promise<string> => {
  if (!tauriMode()) {
    return Promise.resolve(appBaseUrl())
  }
  if (tauriMode() && import.meta.env.VITE_TAURI_API_DEV_SERVER) {
    try {
      const { invoke } = await import('@tauri-apps/api/core')
      await invoke('set_backend_base', {
        url: import.meta.env.VITE_TAURI_API_DEV_SERVER,
      })
    } catch (e) {
      console.error(e)
    }
  }
  if (import.meta.env.VITE_TAURI_API_DEV_SERVER) {
    _url.value = import.meta.env.VITE_TAURI_API_DEV_SERVER
    return Promise.resolve(_url.value)
  }
  if (_url.value) {
    return Promise.resolve(_url.value)
  }
  return getCurrentUrlCmd().then((url) => {
    _url.value = url as string
    return _url.value
  })
}

export const docUrl = () => (import.meta.env.VITE_URL_DOCUMENTATION ?? '')

export const isDevelopment = () => import.meta.env.VITE_ENVIRONMENT_NAME === 'Development'

export const isStage = () => import.meta.env.VITE_ENVIRONMENT_NAME === 'Stage'

export const isStageOrDevelopment = () => isStage() || isDevelopment()

export const isNotDevelopment = () => !isDevelopment()

export const baseUrl = () => import.meta.env.BASE_URL

export const getModuleUrl = () => import.meta.url
